<div class="page-main-header container-fluid d-none" *ngIf="shouldShowNavbar()">
  <div class="main-header-right row">
    <div class="main-header-left text-center col-lg-3">
      <div class="logo-wrapper">
        <a href="javascript:void(0)" routerLink="/">
          <img src="assets/images/logo/NewLogo.png" alt="" /></a>
      </div>
    </div>
    <div class="col-lg-3"></div>
    <div class="main-header-left text-center col-lg-6">
      <div class="logo-wrapper">
        <a href="javascript:void(0)" routerLink="/">
          <img src="assets/images/logo/logo2.png" alt="" /></a>
      </div>
    </div>
    <div class="mobile-sidebar">
      <div class="flex-grow-1 text-end switch-sm">
      </div>
    </div>
    <div class="vertical-mobile-sidebar">
      <i class="fa fa-bars sidebar-bar"> </i>
    </div>
    <div class="nav-right col pull-right right-menu">
      <div class="d-lg-none mobile-toggle pull-right">
        <app-feather-icons [icon]="'more-horizontal'" (click)="openMobileNav()"></app-feather-icons>
      </div>
    </div>
  </div>
</div>

<div class="page-main-header container" *ngIf="shouldShowNavbar()">
  <div class="main-header-right row">
    <div class="col-lg-5">
      <img src="assets/images/logo/NewLogo.png" alt="" />
    </div>
    <div class="col-lg-5 h-100" *ngIf="instituteShow">
      <div *ngIf=showProfile>
        <img class="img-contain" [src]="instituteProfileImg" alt="" width="120px" />
      </div>
    </div>
    <div class="col-lg-5" *ngIf="!instituteShow">

    </div>
    <div class="col-lg-1 float-right">
      <img src="assets/images/logo/logo2.png" alt="" />
    </div>
    <div class="col-lg-1 align-middle">
      <div class="nav-right col pull-right right-menu">
        <ul class="nav-menus">
          <li class="onhover-dropdown ">
            <span class="d-flex user-header"> <img class="img-fluid" src="assets\images\header\user.png"
                alt="" /></span>
            <ul class="onhover-show-div profile-dropdown">
              <div *ngIf="role  =='PORTAL_INSTITUTION'">
                <li (click)="profile()" style="left: -32px;margin-bottom:-20px"> <app-feather-icons
                    [icon]="'users'"></app-feather-icons>Profile</li>
              </div>
              <li (click)="change()" class="d-none"> <app-feather-icons [icon]="'user'"></app-feather-icons>Change
                password </li>
              <li (click)="change()"> <app-feather-icons [icon]="'user'"></app-feather-icons>Change
                password </li>
              <li (click)="logout()"> <app-feather-icons [icon]="'log-out'"></app-feather-icons>Logout </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>